export interface DataTableApiModel<T> {
  current_page: 0;
  data: Array<T>;
  from: number;
  last_page: number;
  per_page: number;
  to: number;
  total: number;
}

export interface DataTable<T> {
  currentPage: 0;
  data: Array<T>;
  from: number;
  lastPage: number;
  perPage: number;
  to: number;
  total: number;
}

export interface Pagination {
  page: number;
  limit: number;
  perPage?: number;
}

export class DataTableComposer {
  static parseDto(dto: DataTableApiModel<any>): DataTable<any> {
    return {
      currentPage: dto.current_page,
      data: dto.data,
      from: dto.from,
      lastPage: dto.last_page,
      perPage: dto.per_page,
      to: dto.to,
      total: dto.total,
    };
  }
}
